import { fluid } from '@helpers/fluid';
import styled from 'styled-components';
const Container = styled.nav `
  display: flex;
  gap: ${fluid(10, 12)};
`;
const ControlsStyles = {
    Container,
};
export default ControlsStyles;
